

<div class="generic-list">
	<ng-container *ngFor="let act of data.actions; let i = index">
		<mat-divider *ngIf="i > 0"></mat-divider>
		<div class="generic-list-item" style="padding: 0 1rem" (click)="openLink(act, $event)">
			<mat-icon *ngIf="act.icon" [svgIcon]="act.icon"></mat-icon>
			<div class="_content"><div class="_title">{{act.text | translate}}</div></div>
		</div>
	</ng-container>
</div>
